import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/vercel/path0/apps/admin/src/components/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_@babel+core@7.28.6_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_babel-plugin-_6ajfppstd5pohoytmwf56j42te/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/admin/src/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["ServerStylesheet"] */ "/vercel/path0/packages/ui/components/server-stylesheet.tsx");
